import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {
  collection,
  doc,
  documentId,
  getDoc,
  getDocs,
  limit,
  onSnapshot,
  orderBy,
  query,
  setDoc,
  where,
} from "firebase/firestore";
import { db } from "../../firebase";
import { useEffect } from "react";
import { useSnackbar } from "notistack";
import { Button, Link, Pagination, alpha } from "@mui/material";
import MyPopover from "../Popover";
import {
  sName,
  sOperate,
  sOrders,
  sProducts,
  sTimestamp,
  sUsers,
} from "../Strings";
import { primaryColor } from "../Theme";
import { usePagination } from "../../hooks/pagination/usePagination";

/* function Username({ uid }) {
  const userRef = doc(db, "users", uid);
  const [user, setUser] = React.useState("-");

  getDoc(userRef).then((snapshot) => {
    setUser(snapshot.data());
  });

  return <div>{user.email}</div>;
} */

function OrderStatus({ status }) {
  if (status === 0) {
    return "Pending";
  } else if (status === 1) {
    return "Confirmed";
  } else if (status === 2) {
    return "Delivered";
  } else if (status === 3) {
    return "Cancelled";
  }
}

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  const [products, setProducts] = React.useState([]);
  const docRef = doc(db, sOrders, row.id);
  const { enqueueSnackbar } = useSnackbar();

  const userRef = doc(db, sUsers, row.uid);
  const [user, setUser] = React.useState([]);

  useEffect(() => {
    getDoc(userRef).then((snapshot) => {
      setUser(snapshot.data());
    });
  }, []);

  const handleOpen = () => {
    setOpen(!open);
    if (row.read === 1) {
      setDoc(docRef, { read: 0 }, { merge: true });
    }
  };

  // const handleActionClick = () => {
  //   // console.log(id, status);
  //   UpdateStatus(row.id, row.status);
  // };

  // check status
  function UpdateStatus(id) {
    if (id !== row.status) {
      SetUpdate(id);
    } else {
      enqueueSnackbar("Already done!", { variant: "error" });
    }
  }

  // push status update
  function SetUpdate(status) {
    setDoc(docRef, { status: status }, { merge: true }).then(() => {
      enqueueSnackbar("Order Updated!", { variant: "success" });
      console.log("Document updated");
    });
  }

  const pids = [];
  // get pids from bundled string
  row.pid.forEach((element) => {
    const array = element.split("~");
    pids.push(array[0]); // add to new array
  });
  // query products with pids
  const productRef = query(
    collection(db, sProducts),
    where(documentId(), "in", pids)
  );

  useEffect(() => {
    getDocs(productRef).then((snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      setProducts(data);
    });
  }, []);

  function getQty(id) {
    // find string in pid with id
    const element = row.pid.find((v) => v.includes(id));
    // split string
    const array = element.split("~");
    // pick out item in 2nd position
    return "x" + array[1];
  }

  const options = [
    {
      name: "Confirm",
      status: 1,
    },
    {
      name: "Delivered",
      status: 2,
    },
    {
      name: "Cancel",
      status: 3,
    },
  ];

  function OrderDetails() {
    const head = [
      "Product Name",
      "Quantity",
      "Price (SSP)",
      "Delivery Fee (SSP)",
    ];

    return (
      <div>
        <h3>Order Details</h3>

        <TableContainer
          sx={{
            minWidth: 650,
            mb: 5,
            border: "1px solid #ccc",
            borderRadius: 2,
          }}
        >
          <Table>
            <TableHead>
              <TableRow>
                {head.map((value) => (
                  <TableCell style={{ color: "grey" }} key={value}>
                    {value}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {products.map((value, key) => (
                <TableRow key={key}>
                  <TableCell component="th" scope="row">
                    {value.name}
                  </TableCell>
                  <TableCell>{getQty(value.id)}</TableCell>
                  <TableCell>{value.price}</TableCell>
                  <TableCell>{value.dFee}</TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell component="th" scope="row">
                  <b>Total + Fee</b>
                </TableCell>
                <TableCell></TableCell>
                <TableCell>
                  <b>{row.amount}</b>
                </TableCell>
                <TableCell>
                  <b>{row.dFee}</b>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    );
  }

  function UserDetails() {
    const head = ["Username", "Email", "Phone", "Address"];

    return (
      <div>
        <h3>User Details</h3>
        <TableContainer
          sx={{
            minWidth: 650,
            my: 3,
            border: "1px solid #ccc",
            borderRadius: 2,
          }}
        >
          <Table>
            <TableHead>
              <TableRow>
                {head.map((value) => (
                  <TableCell style={{ color: "grey" }} key={value}>
                    {value}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>{user.uname}</TableCell>
                <TableCell>{user.email}</TableCell>
                <TableCell>
                  <Link href={"tel:" + user.phone}>{user.phone}</Link>
                </TableCell>
                <TableCell>{user.address}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    );
  }

  return (
    <React.Fragment>
      {/* Table */}
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={handleOpen}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.read === 1 ? (
            <Button
              variant="contained"
              disableElevation
              sx={{
                width: 50,
                height: 30,
                borderRadius: 5,
                fontSize: 10,
                mr: 2,
              }}
            >
              New
            </Button>
          ) : null}
          Order #{row.id}
        </TableCell>
        <TableCell>
          {/* <Username uid={row.uid} /> */}
          {user.email}
        </TableCell>
        <TableCell align="right">
          <div>{row.timestamp.toDate().toDateString()}</div>
          <div style={{ marginTop: 5 }}>
            <span
              style={{
                fontSize: 11,
                border: "1px solid",
                borderColor: alpha(primaryColor, 0.5),
                borderRadius: 50,
                padding: "5px 10px",
                color: primaryColor,
                backgroundColor: alpha(primaryColor, 0.1),
              }}
            >
              {row.timestamp.toDate().toLocaleTimeString()}
            </span>
          </div>
        </TableCell>
        <TableCell align="right">
          <OrderStatus status={row.status} />
        </TableCell>
        <TableCell align="right">
          <MyPopover onClick={UpdateStatus} options={options} />
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          {/* collapse */}
          <Collapse in={open} timeout="auto" mountOnEnter>
            <Box sx={{ margin: 1 }}>
              {/* User Detail */}
              <UserDetails />
              {/* Order Detail */}
              <OrderDetails />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default function Orders() {
  const orderRef = query(
    collection(db, sOrders),
    orderBy(sTimestamp, "desc"),
    limit(5)
  );

  // custom pagination hook
  const { fetchMore, paginatedList, setList, getList } =
    usePagination(orderRef);

  useEffect(() => {
    getList();
  }, []);

  return (
    <>
      <TableContainer sx={{ border: "1px solid #ccc", borderRadius: 3 }}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>Order Number</TableCell>
              <TableCell>User</TableCell>
              <TableCell align="right">Payment Time&nbsp;</TableCell>
              <TableCell align="right">Order Status&nbsp;</TableCell>
              <TableCell align="right">{sOperate}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedList.map((row, key) => (
              <Row key={key} row={row} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Button
        sx={{ mt: 3 }}
        variant="contained"
        onClick={fetchMore}
        disableElevation
      >
        Load More (+5)
      </Button>
    </>
  );
}
